/** Internal dependencies */
import { replaceContent } from './frontendhbs/replaceContent';
import { loadAjax } from './frontendhbs/loadAjax';
import { loadHbstmpl } from './frontendhbs/loadHbstmpl';
import { resetPagination } from './frontendhbs/resetPagination';
import { getCurrentFilters } from './frontendhbs/getCurrentFilters';
import { apiCall } from './frontendhbs/apiCall';
import { populateFiltersFromUrl } from './frontendhbs/populateFiltersFromUrl';
import { throttle } from './utilities';

// Initialize the script as soon as the document is loaded
if (document.readyState !== 'loading') {
    initRest();
} else {
    window.addEventListener('DOMContentLoaded', () => {
        initRest();
    });
}

function initRest() {
    // dynamic ajax content replacer
    const restCallsReplace = document.querySelectorAll('[data-ct-rest-replace]');
    if (restCallsReplace) {
        // If there are any `[data-ct-rest-replace]` elements, loop over all of them and run the `replaceContent` function
        restCallsReplace.forEach((parent) => replaceContent(parent));
    }

    // rest ajax loader
    const restCalls = document.querySelectorAll('[data-ct-rest]');
    if (restCalls) {
        // If there are `[data-ct-rest]` elements, loop over all of them and run the `loadAjax` function
        restCalls.forEach((parent) => loadAjax(parent));
    }

    // handlebars template
    const tmpl = document.querySelectorAll('.hbstmpl');
    if (tmpl) {
        // if there are `.hbstmpl` elements, loop over them and run `loadHbstmpl`.
        tmpl.forEach((element) => loadHbstmpl(element));
    }

    InfinityScroll();
}

window.filterForm = (filterClass) => {
    const filterContainers = document.querySelectorAll(`.${filterClass}`);

    if (filterContainers) {
        filterContainers.forEach((filterContainer) => {
            const parent = filterContainer.closest('[data-ct-rest]');
            if (parent) {
                resetPagination(parent);
                const currentFilters = getCurrentFilters(parent);
                apiCall(parent, currentFilters, true);
            }
        });
    }
};

if (typeof jQuery !== 'undefined') {
    jQuery(function ($) {
        $(document).on('wsf-rendered', function (e, form, form_id, instance_id) {
            const wsForm = document.querySelector(`.wsf-form[data-id="${form_id}"]`);
            const parent = wsForm.closest('[data-ct-rest]');

            if (parent) {
                populateFiltersFromUrl(parent);
            }

            const formFilterRefreshs = document.querySelectorAll(`.wsf-form[data-id="${form_id}"] .filter-refresh`);
            if (!formFilterRefreshs) {
                return;
            }

            formFilterRefreshs.forEach((filterRefresh) => {
                filterRefresh.addEventListener('change', handleFilterRefreshChange);
            });
        });
    });
}

function handleFilterRefreshChange(e) {
    const filterRefresh = e.currentTarget;
    if (filterRefresh.checked) {
        const parent = filterRefresh.closest('[data-ct-rest]');
        if (parent) {
            resetPagination(parent);
            const currentFilters = getCurrentFilters(parent);
            apiCall(parent, currentFilters, true);
        }
    }
}

function InfinityScroll() {
    throttle('scroll', 'optimizedScroll');
    window.addEventListener(
        'optimizedScroll',
        () => {
            const { scrollTop, scrollHeight, clientHeight } = document.documentElement;

            const btnLoadMore = document.querySelector('[data-ct-loadmore]');
            if (scrollTop + clientHeight >= scrollHeight - 400) {
                if (!btnLoadMore.classList.contains('d-none') && parseInt(btnLoadMore.style.opacity) !== 0) {
                    btnLoadMore.click();
                }
            }
        },
        {
            passive: true,
        }
    );
}
